const auto = {
  test: (v) => v === "auto",
  parse: (v) => v
};
export {
  auto
};
